/// <amd-module name="VSS/Redux/Deprecated/HubViewState/HubViewStateModule" />
import { ISagaModule } from "redux-dynamic-modules-saga";
import { IHubViewAwareState } from "VSS/Redux/Deprecated/HubViewState/HubViewStateContracts";
import { hubViewStateSaga } from "VSS/Redux/Deprecated/HubViewState/HubViewStateSaga";
import { hubViewStateReducer } from "VSS/Redux/Deprecated/HubViewState/HubViewStateReducer";
import { IHubViewState } from "VSSUI/Utilities/HubViewState";

export function getHubViewStateModule(hubViewState: IHubViewState): ISagaModule<IHubViewAwareState> {
    return {
        id: "hub-view-state",
        reducerMap: {
            hubViewState: hubViewStateReducer
        },
        sagas: [
            {
                saga: hubViewStateSaga,
                argument: hubViewState
            }
        ]
    };
}
